<script>
import StatusBadge from '@/V2/components/status/StatusBadge.vue';
import { Statuses } from '@/V2/components/status/utils';
import {
  mapRiskLevelToStatus,
  mapRiskLevelToLabel,
} from '@/V2/documents/document-view/document-review-agent/utils';

export default {
  components: {
    StatusBadge,
  },
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      Statuses,
    };
  },
  computed: {
    runStatus() {
      return this.customer?.risk_level
        ? mapRiskLevelToStatus(this.customer?.risk_level)
        : Statuses.DISABLED;
    },
    statusLabel() {
      return this.customer?.risk_level
        ? mapRiskLevelToLabel(this.customer?.risk_level)
        : 'No Rating';
    },
  },
};
</script>

<template>
  <status-badge
    :state="runStatus"
    :label="statusLabel"
    data-testid="customer-fraud-risk-badge"
  />
</template>
